/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useQuery } from '@apollo/client';

export const useTdOrderCreate = (orderCreate,skip:boolean) => {
  console.warn("ORDER_CREATE::::>",skip)
  const { loading, data, error, refetch } = useQuery(
    gql`
      query TDUserLoginOrderCreate($orderCreate: OrderCreate!) {
        TDUserLoginOrderCreate(orderCreate: $orderCreate) {
        userOrderId
    }
    }
    `,
    { 
        variables:orderCreate,
        skip:skip
    }
  );

  return {  loading, error, data, refetch};
};
